import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Archive Marker"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-archive-marker',
    templateUrl: './icon-archive-marker.component.html',
    styleUrls: ['./icon-archive-marker.component.scss'],
    standalone: false
})
export class IconArchiveMarkerComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
